/* The quick view: a product card, on any page, opens a drawer instead of the
 * page — the same pictures, buying form and description — with a link on
 * to the full page, and Add to bag in its foot.
 *
 * It is addressable. Opening pushes /products/<handle>, so the address can
 * be copied and shared, a reload lands on the real product page, and Back
 * closes the drawer. The history entry carries { jwQuick: path }; that is
 * how popstate tells a quick-view entry from the page's own.
 *
 * Liquid renders the contents: the drawer asks the Section Rendering API for
 * /products/<handle>?section_id=product-quickview and puts that HTML in. A
 * hover starts the request, so it is usually back before the click.
 */
(function () {
  var dlg = document.getElementById('jw-quick');
  /* A card tapped before this script ran was held by theme.liquid (Max,
     2026-10-25); it opens below, or is the page if there is no drawer. */
  window.jwQuickReady = true;
  var held = window.jwQuickPending;
  window.jwQuickPending = null;
  if (!dlg || !dlg.showModal) { if (held) location.assign(held.href); return; }
  var body = dlg.querySelector('[data-quick-body]');
  var more = dlg.querySelector('[data-quick-more]');
  var asked = {};        /* path -> promise of the section's HTML */
  var title = document.title;
  var shown = null;      /* the path whose contents are in the body */
  var going = null;      /* Details: the page to go to once Back has run */

  function ask(path) {
    if (!asked[path]) {
      asked[path] = fetch(path + '?section_id=product-quickview', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .catch(function (err) { delete asked[path]; throw err; });
    }
    return asked[path];
  }

  function cardFor(path) {
    var found = null;
    document.querySelectorAll('a.jw-product').forEach(function (a) { if (a.pathname === path) found = a; });
    return found;
  }

  function show(path) {
    var card = cardFor(path);
    var name = card ? card.querySelector('.jw-product__name').textContent : '';
    if (name) document.title = name + ' – ' + title;
    more.href = path;
    if (shown !== path) {
      /* The card's own picture and name while the rest comes. */
      var img = card && card.querySelector('img');
      body.innerHTML = '<div class="jw-quick jw-quick--waiting"><div class="jw-gallery-frame"><div class="jw-gallery">' +
        (img ? '<img src="' + (img.currentSrc || img.src) + '" alt="">' : '') +
        '</div></div><div class="jw-quick__detail"><h3 class="jw-quick__name"></h3></div></div>';
      body.querySelector('.jw-quick__name').textContent = name;
      shown = path;
      ask(path).then(function (html) {
        if (shown !== path) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('.jw-quick');
        if (!fresh) throw new Error('no quick view');
        /* Swap once the new first picture can paint. It is a bigger file
           than the card's, and swapping at once left an empty frame between
           the card's picture going and it arriving (Max, 2026-09-27). A
           second at most, so a slow picture never holds back the form. */
        var first = fresh.querySelector('.jw-gallery img');
        /* If the second runs out first, the card's picture stays painted
           behind the new one until it has loaded, so the frame is never
           empty between them (Max, 2026-10-25: it flickered on a phone,
           where no hover has fetched anything ahead). Taken off on load,
           for a picture with a transparent ground. */
        var low = img && (img.currentSrc || img.src);
        if (first && low && !first.complete) {
          first.style.background = 'url("' + low + '") center / 100% 100% no-repeat';
          first.addEventListener('load', function () { first.style.background = ''; }, { once: true });
        }
        var ready = first && first.decode ? first.decode().catch(function () {}) : Promise.resolve();
        return Promise.race([ready, new Promise(function (r) { setTimeout(r, 1000); })]).then(function () {
          if (shown !== path) return;
          body.replaceChildren(fresh);
          window.jwProduct && window.jwProduct(fresh);
          paint();
        });
      }).catch(function () { location.replace(path); });   /* the page itself, then */
    }
    say(''); readBag();
    if (!dlg.open) dlg.showModal();
  }

  /* A plain click on a card; a click with a modifier (new tab) is left alone. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a.jw-product');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    history.pushState({ jwQuick: a.pathname }, '', a.pathname);
    show(a.pathname);
  });
  document.addEventListener('pointerover', function (e) {
    var a = e.target.closest && e.target.closest('a.jw-product');
    if (a) ask(a.pathname).catch(function () {});
  });

  /* Back and Forward. */
  addEventListener('popstate', function (e) {
    if (going) { location.assign(going); return; }
    if (e.state && e.state.jwQuick) show(e.state.jwQuick);
    else if (dlg.open) dlg.close();
  });

  /* Closed by the button, the backdrop, Escape, or an add to the bag: step
     the address back to the page underneath too. When Back is what closed it,
     the entry is already gone and there is nothing to undo. */
  dlg.addEventListener('close', function () {
    document.title = title;
    if (history.state && history.state.jwQuick) history.back();
  });
  dlg.addEventListener('click', function (e) {
    if (e.target === dlg || e.target.closest('[data-quick-close]')) dlg.close();
    /* Details takes the quick view's entry off first, then goes to
       the page, so the history reads page underneath, product, and Back
       from the product returns to where the card was. Not location.replace(): the address
       is already the product's, and Chrome takes a replace to the same
       address as a reload of that entry — it kept the collection's history
       and Back then showed the product page under /collections/all
       (measured, 2026-09-27). The drawer stays open meanwhile, so its
       picture is the one that morphs. The address carries any ?variant=. */
    var link = e.target.closest('[data-quick-more]');
    if (link && e.button === 0 && !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) {
      e.preventDefault();
      going = location.pathname === link.pathname ? location.href : link.href;
      if (history.state && history.state.jwQuick) history.back();
      else location.assign(going);
    }
  });
  /* Back from the page can restore this one from the back/forward cache
     as it was left: drawer open, on its way somewhere. Put it straight. */
  addEventListener('pageshow', function () {
    going = null;
    if (dlg.open && !(history.state && history.state.jwQuick)) dlg.close();
  });

  /* Add to bag, and the stepper in its place once the chosen variant is in
     the bag (Max, 2026-09-29). The bag is read afresh at each opening. Every
     change goes straight to the bag (window.jwBag, jw-cart.js); taps made
     while one is on its way are gathered into the next, so + + + is one
     request after the first. Down to none, Add to bag comes back.
     The number is the bag's answer, not the tap's (Max, 2026-09-29: a tap
     gave no sign the bag had taken it). It fades while the bag is asked,
     and when the bag has answered the new number slides in — a bigger one
     from the top, a smaller one from the bottom. A refusal is said over the
     foot, and stays until the next change. */
  var add = dlg.querySelector('[data-quick-add]');
  var stepper = dlg.querySelector('[data-quick-stepper]');
  var field = stepper.querySelector('input');
  var oops = dlg.querySelector('[data-quick-error]');
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');
  var inBag = null;      /* variant id -> quantity in the bag */
  var want = null;       /* { id, n, from }: asked for and not yet in the bag; from = before this run of taps */
  var busy = false;
  /* Add to bag's own answer (Max, 2026-10-25): a spinner while the bag is
     asked, a check for a second, then the stepper. 'spin', 'done' or null. */
  var flash = null, flashTimer = null;

  function chosen() { return body.querySelector('.jw-buy input[name="id"]:checked, .jw-buy input[type="hidden"][name="id"]'); }
  function say(msg) {
    if (msg) oops.textContent = msg;   /* going, it keeps its words while it fades */
    oops.classList.toggle('jw-quick__error--shown', !!msg);
  }
  function paint() {
    var v = chosen();
    var n = v && inBag ? inBag[v.value] || 0 : 0;
    var sold = v && (v.disabled || v.hasAttribute('data-sold-out'));
    add.hidden = n > 0 && !flash; stepper.hidden = !(n > 0) || !!flash;
    add.disabled = !v || !inBag || sold;
    add.textContent = flash === 'done' ? 'Added' : sold ? 'Sold out' : 'Add to bag';
    add.classList.toggle('jw-btn--spin', flash === 'spin');
    add.classList.toggle('jw-btn--done', flash === 'done');
    add.setAttribute('aria-busy', String(flash === 'spin'));
    stepper.classList.toggle('jw-quick__stepper--busy', busy);
    if (!busy) field.value = n;
  }
  function roll(up) {
    if (still.matches || !field.animate) return;
    field.animate([{ transform: 'translateY(' + (up ? -100 : 100) + '%)', opacity: 0 }, { transform: 'none', opacity: 1 }],
                  { duration: 280, easing: 'cubic-bezier(.2, .7, .3, 1)' });
  }
  function readBag() {
    clearTimeout(flashTimer); flash = null;
    inBag = null; paint();
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        inBag = {};
        cart.items.forEach(function (item) { inBag[item.variant_id] = (inBag[item.variant_id] || 0) + item.quantity; });
      })
      .catch(function () { inBag = {}; })
      .then(paint);
  }
  /* What the number will be: the run of taps so far, else the bag. */
  function next() {
    var v = chosen();
    return want && v && want.id === v.value ? want.n : v && inBag ? inBag[v.value] || 0 : 0;
  }
  function set(n) {
    var v = chosen();
    if (!v || !inBag) return;
    say('');
    want = { id: v.value, n: n, from: want && want.id === v.value ? want.from : inBag[v.value] || 0 };
    if (!busy) send();
  }
  function send() {
    var w = want;
    if (!w || w.n === (inBag[w.id] || 0)) { want = null; busy = false; stepper.classList.add('jw-buy__stepper--rest'); paint(); return; }
    busy = true; paint();
    window.jwBag(w.id, inBag[w.id] || 0, w.n)
      .then(function (n) {
        inBag[w.id] = n;
        if (flash === 'spin') {
          flash = n > 0 ? 'done' : null;
          flashTimer = setTimeout(function () { flash = null; paint(); }, 1000);
        }
        if (want !== w) return;   /* more taps to send: the number waits for them */
        want = null; busy = false; paint();
        if (n !== w.from) roll(n > w.from);
        if (n < w.n) say('Only ' + n + ' available, and all ' + n + ' are in your bag');
      }, function (err) { want = null; flash = null; say(err.message); })
      .then(send);
  }

  /* The - and + wear their hover grey from the press to the bag's answer,
     then let it go, though the pointer is still on them — a phone keeps a
     tapped button hovered until the next tap (Max, 2026-09-29). The next
     press, or the mouse leaving the pill, gives it back. */
  stepper.addEventListener('pointerdown', function () { stepper.classList.remove('jw-buy__stepper--rest'); });
  stepper.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') stepper.classList.remove('jw-buy__stepper--rest'); });
  add.addEventListener('click', function () {
    if (flash) return;
    flash = 'spin'; paint();
    set(1);
  });
  stepper.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-step]');
    if (b) set(Math.max(0, next() + +b.dataset.quickStep));
  });
  field.addEventListener('change', function () {
    var n = parseInt(field.value, 10);
    if (n >= 0) set(n); else paint();
  });
  field.addEventListener('keydown', function (e) { if (e.key === 'Enter') field.blur(); });
  body.addEventListener('change', function (e) { if (e.target.name === 'id') { say(''); paint(); } });

  /* Last, once everything show() needs is in place. */
  if (held) held.click();
})();
